import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { Inject, Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { RequestService } from 'src/app/services/request.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import Contact from 'src/app/model/Contact/contact';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import { SnackService } from 'src/app/services/snack.service';

@Component({
  selector: 'company-contacts-dialog',
  templateUrl: './company-contacts-dialog.component.html',
  styleUrls: ['./company-contacts-dialog.component.scss'],
  providers: [FormatPhoneNumber],
})
export class CompanyContactsDialogComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  public inputCompany;
  @Input()
  public inputContact;
  private companySearchTermChanged: Subject<string> = new Subject<string>();
  public companySearchTerm = '';
  private contactSearchTermChanged: Subject<string> = new Subject<string>();
  public contactSearchTerm = '';
  public companySearchResult = [];
  public contactSearchResult = [];
  public displayedCompanies = [];
  public displayedContacts = [];

  constructor(
    public dialogRef: MatDialogRef<CompanyContactsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private requestService: RequestService,
    private snackService: SnackService,
    public formatPhoneNumber: FormatPhoneNumber
  ) {
    super();
    this.inputCompany = data.company;
    this.inputContact = data.contact;
  }

  ngOnInit() {
    if (this.inputCompany != null) {
      this.displayedContacts = this.inputCompany.contacts.filter(
        (c) => !c.archived
      );
      this.addSubscription(
        this.contactSearchTermChanged,
        (data) => {
          if (data && data.length > 1) {
            this.addSubscription(this.searchContacts(data), (response) => {
              this.contactSearchResult = response.body;
            });
          } else {
            this.contactSearchResult = [];
          }
        },
        (err) => {},
        500
      );
    } else {
      // this.inputContact != null
      this.displayedCompanies = this.inputContact.companies.filter(
        (c) => !c.archived
      );
      this.addSubscription(
        this.companySearchTermChanged,
        (data) => {
          if (data && data.length > 1) {
            this.addSubscription(this.searchCompanies(data), (response) => {
              this.companySearchResult = response.body;
            });
          } else {
            this.companySearchResult = [];
          }
        },
        (err) => {},
        500
      );
    }
  }

  onCompanySearchTermChanged(searchTerm: string) {
    this.companySearchTermChanged.next(searchTerm);
  }

  onContactSearchTermChanged(searchTerm: string) {
    this.contactSearchTermChanged.next(searchTerm);
  }

  searchCompanies(term) {
    return this.requestService.get('/companies/search/' + term);
  }

  searchContacts(term) {
    return this.requestService.get('/contacts/search/' + term);
  }

  contactSelected(event) {
    if (
      this.inputCompany.contacts.find((c) => c.id === event.value.id) == null
    ) {
      this.inputCompany.contacts.push(event.value);
      this.displayedContacts.push(event.value);
    }
    this.contactSearchTerm = '';
  }

  companySelected(event) {
    if (
      this.inputContact.companies.find((c) => c.id === event.value.id) == null
    ) {
      this.inputContact.companies.push(event.value);
      this.displayedCompanies.push(event.value);
    }
    this.companySearchTerm = '';
  }

  deleteContact(event) {
    for (let i = 0; i < this.inputCompany.contacts.length; i++) {
      if (this.inputCompany.contacts[i].id === event.id) {
        this.inputCompany.contacts.splice(i, 1);
        break;
      }
    }
    for (let i = 0; i < this.displayedContacts.length; i++) {
      if (this.displayedContacts[i].id === event.id) {
        this.displayedContacts.splice(i, 1);
        break;
      }
    }
  }

  deleteCompany(event) {
    for (let i = 0; i < this.inputContact.companies.length; i++) {
      if (this.inputContact.companies[i].id === event.id) {
        this.inputContact.companies.splice(i, 1);
        break;
      }
    }
    for (let i = 0; i < this.displayedCompanies.length; i++) {
      if (this.displayedCompanies[i].id === event.id) {
        this.displayedCompanies.splice(i, 1);
        break;
      }
    }
  }

  getContactLabel(contact: Contact) {
    let email = contact.emails.find((e) => e.type === 'primary');
    if (email != null) {
      return this.getContactPrintName(contact) + ': ' + email.email;
    } else {
      return this.getContactPrintName(contact);
    }
  }

  getContactPrintName(contact: Contact) {
    return contact.firstName == null || contact.firstName.length < 1
      ? contact.lastName
      : contact.firstName + ' ' + contact.lastName;
  }

  save() {
    if (this.inputCompany != null) {
      this.saveContacts();
    } else {
      // this.inputContact != null
      this.saveCompanies();
    }
  }

  private saveContacts() {
    this.addSubscription(
      this.requestService.post(
        {
          contactIds: this.inputCompany.contacts.map((c) => {
            return c.id;
          }),
        },
        '/companies/linkToContacts/' + this.inputCompany.id
      ),
      (data) => {
        this.snackService.showSuccess('Contacten succesvol aangepast');
        this.dialogRef.close();
      }
    );
  }

  private saveCompanies() {
    this.addSubscription(
      this.requestService.post(
        {
          id: this.inputContact.id,
          companyIds: this.inputContact.companies.map((c) => {
            return c.id;
          }),
        },
        '/contacts/linkToCompanies/' + this.inputContact.id
      ),
      (data) => {
        this.snackService.showSuccess('Bedrijven succesvol aangepast');
        this.dialogRef.close();
      }
    );
  }
}
